import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import ResetPasswordHook from "../../hook/auth/reset-password-hook";
import ValidTORMessages from "./ValidMessages/ValidMessages";
import validatePassword from "../../Feature/PassworValidRegex";
const RsetPasswordPage = () => {
  const [
    password,
    confirmPassword,
    OnChangePassword,
    OnChangeConfirmPassword,
    onSubmit,
    showPassword,
    showPasswordConfirm,
    togglePasswordVisibility,
    togglePasswordConFirmVisibility,
    isComplate,
  ] = ResetPasswordHook();
  const handleKeyUp = (e) => {
    if (e.code === "Enter" && isComplate) {
      onSubmit();
    }
  };
  return (
    <Container style={{ minHeight: "690px", width: "375px" }}>
      <Row className="py-5 d-flex justify-content-center ">
        <Col sm="12" className="d-flex flex-column ">
          <label className="mx-auto title-login">ادخل كلمه السر الجديده</label>
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-lock"></i>
            </div>
            <input
              value={password}
              onChange={OnChangePassword}
              placeholder="كلمه السر..."
              type={showPassword ? "text" : "password"}
              onKeyUp={handleKeyUp}
              className="user-input"
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
            <button
              className="bg-white"
              type="button"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className="fa fa-eye-slash"></i> // Hide password icon
              ) : (
                <i className="fa fa-eye"></i> // Show password icon
              )}
            </button>
          </div>
          {password.length > 1 ? (
            <ValidTORMessages validlistError={validatePassword(password)} />
          ) : null}
          <div class="input-group my-2 d-flex align-items-center justify-content-center w-100 rounded shadow-sm p-1 bg-white">
            <div
              class=" h-100 bg-white input-group-text input-group-prepend "
              id="basic-addon1"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            >
              <i class="fas fa-lock"></i>
            </div>
            <input
              value={confirmPassword}
              onChange={OnChangeConfirmPassword}
              placeholder="تأكيد كلمه السر..."
              type={showPasswordConfirm ? "text" : "password"}
              onKeyUp={handleKeyUp}
              className="user-input"
              style={{
                flex: "1",
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
            />
            <button
              className="bg-white"
              type="button"
              style={{
                border: "none",
                outline: "none",
                borderRadius: "0",
              }}
              onClick={togglePasswordConFirmVisibility}
            >
              {showPasswordConfirm ? (
                <i className="fa fa-eye-slash"></i> // Hide password icon
              ) : (
                <i className="fa fa-eye"></i> // Show password icon
              )}
            </button>
          </div>
          {confirmPassword.length > 1 ? (
            <ValidTORMessages validlistError={validatePassword(password)} />
          ) : null}

          {isComplate ? (
            <button onClick={onSubmit} className="btn-login">
              حفظ
            </button>
          ) : (
            <button disabled className="bg-grey-500 btn">
              حفظ
            </button>
          )}
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default RsetPasswordPage;
